import { createSelector } from "reselect";
import { IUserState } from "src/types";

const getUserData = (state: { user: IUserState }) => state.user.data;

export const selectUserId = createSelector(getUserData, (user) => {
  const currentUser = user!;
  return currentUser._id;
});
